import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from '../base/BaseAdapter';
import { isHTTPUrl } from '../../core/utils';
/*
  qq小程序UA 走的 wx小程序逻辑, 该文件可考虑废弃
*/
var QQMPAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(QQMPAdapter, _BaseAdapter);
  var _super = _createSuper(QQMPAdapter);
  function QQMPAdapter(_native) {
    var _this;
    _classCallCheck(this, QQMPAdapter);
    return _this = _super.call(this, _native, ['https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js', 'https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.4.40.js'], function () {
      _this.zzwa = window.zzwa;
      _this.mqq = window.qq.miniProgram;
      _this.__sdk = _this.mqq;
      if (_this.zzwa.init) _this.zzwa.init();
    });
  }
  _createClass(QQMPAdapter, [{
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj) {
        var targetUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                targetUrl = obj.targetUrl;
                if (targetUrl) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                if (isHTTPUrl(targetUrl)) {
                  _get(_getPrototypeOf(QQMPAdapter.prototype), "skipToUrl", this).call(this, obj);
                } else {
                  this.mqq.navigateTo({
                    url: targetUrl
                  });
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function skipToUrl(_x) {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }]);
  return QQMPAdapter;
}(BaseAdapter);
QQMPAdapter.pluginName = 'QQMPAdapter';
QQMPAdapter.platform = [{
  rule: /QMA\//i,
  name: 'qqmp'
}];
export { QQMPAdapter as default };